module.exports = {"description":"雲商城後臺系統","username":"請輸入用戶名","password":"請輸入密碼","login":"登錄"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/zh-TW.json
// module id = JzTv
// module chunks = 72